<script>
import MyNav from "@/components/MyNav.vue";

export default {
  name: "MainFooter",
  components: {MyNav}
}
</script>

<template>
  <div class="main-footer">
    <div class="main-footer-inner">
      <router-link to="/">
        <img width="340" height="60" src="../assets/img/common/site_title_noyear.svg" alt="Recruiting Kureha" />
      </router-link>
      <div>
        <router-link to="/">
          <span>クレハ採用サイトTOP</span>
          <img src="../assets/img/common/circle-arrow-right.svg"  alt=""/>
        </router-link>
      </div>
      <my-nav :is-footer="true" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-footer{
  background-color: #F9F9F9;
  &-inner{
    max-width: 1105px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 68px 0;
    @media print, screen and (max-width: 900px){
      padding: 76px 0;
      max-width: 480px;
    }

    & >div{
      padding: 0 24px;
      & > a{
        display: flex;
        max-width: fit-content;
        align-items: center;
        justify-content: center;
        height: 50px;
        background-color: white;
        border: 2px solid black;
        border-radius: 4px;
        margin: 48px auto 22px auto;
        min-width: 288px;
        box-sizing: border-box;
        @media print, screen and (max-width: 900px){
          min-width: 100%;
          justify-content: space-between;
          padding: 0 16px;
          margin-bottom: 45px;
        }
        & > img {
          display: none;
          @media print, screen and (max-width: 900px){ display: block }
        }
        & > span{
          font-size: 16px;
          font-weight: 700;
          color: #3C3C3C;
        }
      }
    }
    & > a{
      &:first-child{
        display: flex;
        align-items: center;
        max-width: fit-content;
        margin: 0 auto;
        @media print, screen and (max-width: 900px){
          max-width: 322px;
          & > img{
            width: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
}
</style>
